export default (value) => {
  if(!value)
    return null;

  return Buffer.from(value, 'base64').toString();
}
